// import React, { useEffect, useState, useRef } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { Radio } from "react-feather";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { ErrorToast } from "../../ToastComponent";

// export const CollectionOfEMIModalPopup = ({CollectionOFEMIDatafetchFunc}) => {
//   const initialTableData = [
//     {
//       module: "Projects",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Tasks",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Chat",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Estimates",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Invoices",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Timing Sheets",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//   ];

//   //   let yourDate = new Date()
//   // // yourDate.toISOString().split('T')[0]

//   // const today=(yourDate.toISOString().split('T')[0])

//   const [tableData, setTableData] = useState(initialTableData)

//   // const [userId,setUserId] = useState('')

//   // useEffect(() => {
//   //  const id= JSON.parse(sessionStorage.getItem('user'))
//   // setUserId(id)
//   // }, [])

//   const fileInputRef = useRef(null);

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem('user'))?.id
//       console.log("id", id)
//       const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     AllFileLoginData()
//   }, [])

//   const [radioValue, setRadioValue] = useState(false);

//   const [isCollected, setIsCollected] = useState(false)
//   const [isNotCollected, setIsNotCollected] = useState(false)
//   const [isPartialCollected, setIsPartialCollected] = useState(false)

//   // const [location, setLocation] = useState(null);

//   const [LocalFormData, setLocalFormData] = useState({
//     BranchId: Number,
//     Name: "",
//     Mobile: "",
//     ReferenceNumber: "",
//     IsEMICollected: 0,
//     Selfie: null,
//     ExpectedDate: "",
//     Latitude: "",
//     Longitude: "",
//   });

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setLocalFormData({ ...LocalFormData, Selfie: file });
//   };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, ExpectedDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {

//         const { latitude, longitude } = position.coords;
//         setLocalFormData({ ...LocalFormData, Latitude: latitude, Longitude: longitude });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, [])

//   // console.log("location",location?.latitude)

//   const HandleSubmit = async () => {

//     const formatDateToUTC = (dateString) => {
//       const date = new Date(dateString);
//       const year = date.getUTCFullYear();
//       const month = String(date.getUTCMonth() + 1).padStart(2, '0');
//       const day = String(date.getUTCDate()).padStart(2, '0');
//       const hours = String(date.getUTCHours()).padStart(2, '0');
//       const minutes = String(date.getUTCMinutes()).padStart(2, '0');
//       const seconds = String(date.getUTCSeconds()).padStart(2, '0');
//       const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');
//       return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
//     };

//     console.log(isCollected, isNotCollected, isPartialCollected)

//     if (LocalFormData.Mobile.length !== 10) {
//       ErrorToast("Mobile Number must be exactly 10 digits.");
//       return;
//     }

//     setLocalFormData(prev => ({
//       ...prev,
//       IsEMICollected: isCollected,
//     }))

//     let collectedStatus = 0;
//     if (isCollected) {
//       collectedStatus = 1;
//     } else if (isPartialCollected) {
//       collectedStatus = 2;
//     } else if (isNotCollected) {
//       collectedStatus = 3;
//     }

//     const formData = new FormData();
//     formData.append("BranchId", LocalFormData.BranchId);
//     formData.append("Name", LocalFormData.Name);
//     formData.append("Mobile", LocalFormData.Mobile);
//     formData.append("ReferenceNumber", LocalFormData.ReferenceNumber);
//     formData.append("IsEMICollected", collectedStatus);
//     formData.append("Selfie", LocalFormData.Selfie);
//     // formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
//     formData.append("Latitude", LocalFormData.Latitude);
//     formData.append("Longitude", LocalFormData.Longitude);

//     if (isNotCollected || isPartialCollected) {
//       formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
//     }

//     // console.log(formData)

//     try {
//       const response = await axios.post(`${Api_Url}api/v1/EMICollection`, formData, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//           "Content-Type": "multipart/form-data",
//         }
//       })
//       CollectionOFEMIDatafetchFunc()
//       resetForm()
//       SuccessToast("EMI Collection Submitted Successfully")
//       console.log(response)

//     } catch (error) {
//       return error.message;
//     }

//   }

//   const resetForm = () => {
//     setLocalFormData({
//       BranchId: Number,
//     Name: "",
//     Mobile: "",
//     ReferenceNumber: "",
//     IsEMICollected: 0,
//     Selfie: null,
//     ExpectedDate: "",
//     });
//     setIsCollected(false)
//     setIsNotCollected(false)
//     setIsPartialCollected(false)
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const handleCheckboxChange = (module, column) => {
//     // Create a copy of the tableData
//     const updatedTableData = [...tableData];

//     // Find the row with the specified module
//     const row = updatedTableData.find((item) => item.module === module);

//     // Toggle the checkbox value
//     row[column] = !row[column];

//     // Set the updated data
//     setTableData(updatedTableData);
//   };

//   const [allbranch, setAllBranch] = useState('')

//   const AllBranchName = async () => {
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       // console.log("response",response.data.data)
//       setAllBranch(response.data.data)
//     } catch (error) {
//       console.log("object", error)
//     }
//   }
//   console.log(allbranch)

//   useEffect(() => {
//     AllBranchName()
//   }, [])

//   const validateMobileNumber = (number) => {
//     const regex = /^[0-9]{0,10}$/;
//     return regex.test(number);
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value;
//     if (validateMobileNumber(value)) {
//       setLocalFormData({
//         ...LocalFormData,
//         Mobile: value,
//       });
//     }}

//   return (
//     <>
//       <div id="add_client" className="modal custom-modal fade" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Collecton Of EMI</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYP-KKtRJXm9qK7k2_PA1utxbxWdpzGIdulQ&s'
//                   alt='mohit'
//                   className="img-fluid rounded-circle"
//                   style={{ width: '100px', height: '100px' }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length > 0 && allbranch.map((res) => (
//                           <option value={res.id}>{res.name}</option>
//                         ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control"
//                         type="text" value={LocalFormData.Name}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.Mobile} onChange={handleMobileChange} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="col-form-label">Upload Document <span className="text-danger">*</span></label>
//                     <input
//                       className="form-control"
//                       type="file"
//                       accept="image/*"
//                       ref={fileInputRef}
//                       // value={LocalFormData.Selfie}
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       EMI Collected <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         // value="collected"
//                         checked={isCollected}
//                         onChange={(e) => { setIsCollected(e.target.checked); setIsNotCollected(false); setIsPartialCollected(false); }}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault1">
//                         Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault2"
//                         id="flexRadioDefault2"
//                         // value="partial collected"
//                         checked={isPartialCollected}
//                         onChange={(e) => { setIsPartialCollected(e.target.checked); setIsCollected(false) }}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         Partial Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault2"
//                         id="flexRadioDefault3"
//                         // value="not collected"
//                         checked={isNotCollected}
//                         onChange={(e) => { setIsNotCollected(e.target.checked); setIsCollected(false) }}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault3">
//                         Not Collected
//                       </label>
//                     </div>
//                   </div>

//                   {/* isEmiCollected = isCollected == true && ... */}

//                   {
//                     isCollected === true && isNotCollected === false && isPartialCollected === false ? (
//                       <div className="col-md-6">
//                         <div className="input-block mb-3">
//                           <label className="col-form-label">
//                             ReferenceNumber <span className="text-danger">*</span>
//                           </label>
//                           <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                         </div>
//                       </div>
//                     )
//                       // : isNotCollected === true || isPartialCollected === true && isCollected === false ?
//                       //   (<div div className="col-md-6">
//                       //     <div className="input-block mb-3">
//                       //       <label className="col-form-label">
//                       //         Visit Date <span className="text-danger">*</span>
//                       //       </label>
//                       //       <DatePicker
//                       //         selected={LocalFormData.ExpectedDate}
//                       //         onChange={handleDateChange}
//                       //         className="form-control"
//                       //       />
//                       //     </div>
//                       //   </div>
//                       //   ) : (isNotCollected === false || isPartialCollected === true && isPartialCollected === false || isNotCollected === true) ?
//                       //     (<div div className="col-md-6">
//                       //       <div className="input-block mb-3">
//                       //         <label className="col-form-label">
//                       //           Visit Date <span className="text-danger">*</span>
//                       //         </label>
//                       //         <DatePicker
//                       //           selected={LocalFormData.ExpectedDate}
//                       //           onChange={handleDateChange}
//                       //           className="form-control"
//                       //         />
//                       //       </div>
//                       //     </div>) :
//                       //     (
//                       //       <div className="col-md-6">
//                       //         <div className="input-block mb-3">
//                       //           <label className="col-form-label">
//                       //             ReferenceNumber <span className="text-danger">*</span>
//                       //           </label>
//                       //           <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                       //         </div>
//                       //       </div>)
//                       :
//                       isCollected === false && isPartialCollected === false && isNotCollected === false ? null : (<div div className="col-md-6">
//                         <div className="input-block mb-3">
//                           <label className="col-form-label">
//                             Expected Date <span className="text-danger">*</span>
//                           </label>
//                           <DatePicker
//                             selected={LocalFormData.ExpectedDate}
//                             onChange={handleDateChange}
//                             className="form-control"
//                           />
//                         </div>
//                       </div>)
//                   }

//                   {/* if (isCollected === true ) {
//                     <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                       ReferenceNumber <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                     </div>
//                   </div>
//                   }else if (isNotCollected === true || isPartialCollected === true){
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   }else if(isCollected === false || isNotCollected === true || isPartialCollected === false){
//                     <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Visit Date <span className="text-danger">*</span>
//                       </label>
//                       <DatePicker
//                         selected={LocalFormData.ExpectedDate}
//                         onChange={handleDateChange}
//                         className="form-control"
//                       />
//                     </div>
//                   </div>
//                   }else{
//                     ""
//                   }
//                   } */}

//                   {/* Conditional rendering based on radio selection */}
//                   {/* {(LocalFormData.IsEMICollected === "partial collected" || LocalFormData.IsEMICollected === "not collected") ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   ):  <div className="col-md-6">
//                   <div className="input-block mb-3">
//                     <label className="col-form-label">
//                     ReferenceNumber <span className="text-danger">*</span>
//                     </label>
//                     <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                   </div>
//                 </div>} */}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div >
//       </div >

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//             <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length > 0 && allbranch.map((res) => (
//                           <option value={res.id}>{res.name}</option>
//                         ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control"
//                         type="text" value={LocalFormData.Name}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.Mobile} onChange={(e) => setLocalFormData({ ...LocalFormData, Mobile: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="col-form-label">Upload Document <span className="text-danger">*</span></label>
//                     <input
//                       className="form-control"
//                       type="file"
//                       // value={LocalFormData.Selfie}
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       EMI Collected <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         // value="collected"
//                         checked={isCollected}
//                         onChange={(e) => { setIsCollected(e.target.checked); setIsNotCollected(false); setIsPartialCollected(false); }}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault1">
//                         Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault2"
//                         id="flexRadioDefault2"
//                         // value="partial collected"
//                         checked={isPartialCollected}
//                         onChange={(e) => { setIsPartialCollected(e.target.checked); setIsCollected(false) }}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         Partial Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault2"
//                         id="flexRadioDefault3"
//                         // value="not collected"
//                         checked={isNotCollected}
//                         onChange={(e) => { setIsNotCollected(e.target.checked); setIsCollected(false) }}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault3">
//                         Not Collected
//                       </label>
//                     </div>
//                   </div>

//                   {/* isEmiCollected = isCollected == true && ... */}

//                   {
//                     isCollected === true && isNotCollected === false && isPartialCollected === false ? (
//                       <div className="col-md-6">
//                         <div className="input-block mb-3">
//                           <label className="col-form-label">
//                             ReferenceNumber <span className="text-danger">*</span>
//                           </label>
//                           <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                         </div>
//                       </div>
//                     )
//                       // : isNotCollected === true || isPartialCollected === true && isCollected === false ?
//                       //   (<div div className="col-md-6">
//                       //     <div className="input-block mb-3">
//                       //       <label className="col-form-label">
//                       //         Visit Date <span className="text-danger">*</span>
//                       //       </label>
//                       //       <DatePicker
//                       //         selected={LocalFormData.ExpectedDate}
//                       //         onChange={handleDateChange}
//                       //         className="form-control"
//                       //       />
//                       //     </div>
//                       //   </div>
//                       //   ) : (isNotCollected === false || isPartialCollected === true && isPartialCollected === false || isNotCollected === true) ?
//                       //     (<div div className="col-md-6">
//                       //       <div className="input-block mb-3">
//                       //         <label className="col-form-label">
//                       //           Visit Date <span className="text-danger">*</span>
//                       //         </label>
//                       //         <DatePicker
//                       //           selected={LocalFormData.ExpectedDate}
//                       //           onChange={handleDateChange}
//                       //           className="form-control"
//                       //         />
//                       //       </div>
//                       //     </div>) :
//                       //     (
//                       //       <div className="col-md-6">
//                       //         <div className="input-block mb-3">
//                       //           <label className="col-form-label">
//                       //             ReferenceNumber <span className="text-danger">*</span>
//                       //           </label>
//                       //           <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                       //         </div>
//                       //       </div>)
//                       :
//                       isCollected === false && isPartialCollected === false && isNotCollected === false ? null : (<div div className="col-md-6">
//                         <div className="input-block mb-3">
//                           <label className="col-form-label">
//                             Expected Date <span className="text-danger">*</span>
//                           </label>
//                           <DatePicker
//                             selected={LocalFormData.ExpectedDate}
//                             onChange={handleDateChange}
//                             className="form-control"
//                           />
//                         </div>
//                       </div>)
//                   }

//                   {/* if (isCollected === true ) {
//                     <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                       ReferenceNumber <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                     </div>
//                   </div>
//                   }else if (isNotCollected === true || isPartialCollected === true){
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   }else if(isCollected === false || isNotCollected === true || isPartialCollected === false){
//                     <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Visit Date <span className="text-danger">*</span>
//                       </label>
//                       <DatePicker
//                         selected={LocalFormData.ExpectedDate}
//                         onChange={handleDateChange}
//                         className="form-control"
//                       />
//                     </div>
//                   </div>
//                   }else{
//                     ""
//                   }
//                   } */}

//                   {/* Conditional rendering based on radio selection */}
//                   {/* {(LocalFormData.IsEMICollected === "partial collected" || LocalFormData.IsEMICollected === "not collected") ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   ):  <div className="col-md-6">
//                   <div className="input-block mb-3">
//                     <label className="col-form-label">
//                     ReferenceNumber <span className="text-danger">*</span>
//                     </label>
//                     <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                   </div>
//                 </div>} */}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// Modal

import React, { useEffect, useState, useRef } from "react";
import { DatePicker, Modal } from "antd";
import axios from "axios";
import moment from "moment";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import { Api_Url } from "../../../config/config";
import { AllFormsUpperphoto } from "../../../Routes/ImagePath";

export const CollectionOfEMIModalPopup = ({
  CollectionOFEMIDatafetchFunc,
  onClose,
}) => {
  const initialTableData = [
    // Initial table data (unchanged)
  ];

  const [tableData, setTableData] = useState(initialTableData);
  const fileInputRef = useRef(null);

  const [radioValue, setRadioValue] = useState(null);
  const [isCollected, setIsCollected] = useState(false);
  const [isNotCollected, setIsNotCollected] = useState(false);
  const [isPartialCollected, setIsPartialCollected] = useState(false);
  const [loading, setLoading] = useState(false);

  const [LocalFormData, setLocalFormData] = useState({
    BranchId: "",
    Name: "",
    Mobile: "",
    ReferenceNumber: "",
    IsEMICollected: 0,
    Selfie: null,
    ExpectedDate: null,
    Latitude: "",
    Longitude: "",
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setLocalFormData((prev) => ({ ...prev, Selfie: file }));
  };

  const handleDateChange = (date) => {
    setLocalFormData((prev) => ({ ...prev, ExpectedDate: date }));
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setLocalFormData((prev) => ({
          ...prev,
          Latitude: latitude,
          Longitude: longitude,
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const HandleSubmit = async () => {
    setLoading(true);

    // Validate required fields
    if (!LocalFormData.BranchId) {
      ErrorToast("Branch is required.");
      setLoading(false);
      return;
    }

    if (!LocalFormData.Name) {
      ErrorToast("Customer Name is required.");
      setLoading(false);
      return;
    }

    if (LocalFormData.Mobile.length !== 10) {
      ErrorToast("Mobile Number must be exactly 10 digits.");
      setLoading(false);
      return;
    }

    if (!isCollected && !isPartialCollected && !isNotCollected) {
      ErrorToast("Please select EMI collection status.");
      setLoading(false);
      return false;
    }
    if (isCollected && !LocalFormData.ReferenceNumber) {
      ErrorToast("Please enter the reference number for full collection.");
      return false;
    }
    if ((isPartialCollected || isNotCollected) && !LocalFormData.ExpectedDate) {
      ErrorToast("Please select an expected visit date for partial or no collection.");
      return false;
    }

    if (!LocalFormData.Selfie) {
      ErrorToast("Upload Document is required.");
      setLoading(false);
      return;
    }

    // if (isNotCollected || isPartialCollected) {
    //   if (!LocalFormData.ExpectedDate) {
    //     ErrorToast("Expected Date is required.");
    //     setLoading(false);
    //     return;
    //   }
    // }

    const collectedStatus = isCollected
      ? 1
      : isPartialCollected
      ? 2
      : isNotCollected
      ? 3
      : 0;

    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("Name", LocalFormData.Name);
    formData.append("Mobile", LocalFormData.Mobile);
    formData.append("ReferenceNumber", LocalFormData.ReferenceNumber);
    formData.append("IsEMICollected", collectedStatus);
    formData.append("Selfie", LocalFormData.Selfie);
    if (isNotCollected || isPartialCollected) {
      formData.append(
        "ExpectedDate",
        LocalFormData.ExpectedDate ? LocalFormData.ExpectedDate.toISOString() : ""
      );
    }
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/EMICollection`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      CollectionOFEMIDatafetchFunc();
      resetForm();
      SuccessToast("EMI Collection Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("An error occurred while submitting the form.");
      console.error(error);
    }
    setLoading(false);
  };

  const resetForm = () => {
    setLocalFormData({
      BranchId: "",
      Name: "",
      Mobile: "",
      ReferenceNumber: "",
      IsEMICollected: 0,
      Selfie: null,
      ExpectedDate: null,
      Latitude: "",
      Longitude: "",
    });
    setIsCollected(false);
    setIsNotCollected(false);
    setIsPartialCollected(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const [allbranch, setAllBranch] = useState([]);

  const AllBranchName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllBranch(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    AllBranchName();
  }, []);

  const validateMobileNumber = (number) => /^[0-9]{0,10}$/.test(number);

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (validateMobileNumber(value)) {
      setLocalFormData((prev) => ({ ...prev, Mobile: value }));
    }
  };

  return (
    <Modal
      title={<h4>Add EMI Collection</h4>}
      open={true}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <div className="d-flex justify-content-between align-items-center" key="footer">
          <button className="btn btn-danger submit-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary submit-btn"
            onClick={HandleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>,
      ]}
      width={600}
      maskClosable={false}
      closeIcon={<span style={{ color: "red" }}>X</span>}
    >
      <div className="modal-body mt-5">
        <div className="profile-image text-center mt-4 mb-4">
          <img
            src={AllFormsUpperphoto}
            alt="Profile"
            className="img-fluid rounded-circle"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <form>
          <div className="row">
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Branch <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={LocalFormData.BranchId}
                  onChange={(e) =>
                    setLocalFormData((prev) => ({
                      ...prev,
                      BranchId: e.target.value,
                    }))
                  }
                >
                  <option value="">Select Branch</option>
                  {allbranch.map((res) => (
                    <option key={res.id} value={res.id}>
                      {res.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Customer Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.Name}
                  onChange={(e) =>
                    setLocalFormData((prev) => ({
                      ...prev,
                      Name: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Mobile <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.Mobile}
                  onChange={handleMobileChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <label className="col-form-label">
                Upload Document <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileChange}
              />
            </div>
            <div className="col-md-12">
                <label className="col-form-label">
                  EMI Collected <span className="text-danger">*</span>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    // value="collected"
                    checked={isCollected}
                    onChange={(e) => {
                      setIsCollected(e.target.checked);
                      setIsNotCollected(false);
                      setIsPartialCollected(false);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    Collected
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault2"
                    id="flexRadioDefault2"
                    // value="partial collected"
                    checked={isPartialCollected}
                    onChange={(e) => {
                      setIsPartialCollected(e.target.checked);
                      setIsCollected(false);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault2"
                  >
                    Partial Collected
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault2"
                    id="flexRadioDefault3"
                    // value="not collected"
                    checked={isNotCollected}
                    onChange={(e) => {
                      setIsNotCollected(e.target.checked);
                      setIsCollected(false);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault3"
                  >
                    Not Collected
                  </label>
                </div>
              </div>

              {/* isEmiCollected = isCollected == true && ... */}

              {isCollected === true &&
              isNotCollected === false &&
              isPartialCollected === false ? (
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      ReferenceNumber <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      value={LocalFormData.ReferenceNumber}
                      onChange={(e) =>
                        setLocalFormData({
                          ...LocalFormData,
                          ReferenceNumber: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              ) : isCollected === false &&
                isPartialCollected === false &&
                isNotCollected === false ? null : (
                <div div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Expected Date <span className="text-danger">*</span>
                    </label>
                    <DatePicker
                      selected={LocalFormData.ExpectedDate}
                      onChange={handleDateChange}
                      className="form-control"
                    />
                  </div>
                </div>
              )}
            </div>
        </form>
      </div>
    </Modal>
  );
};

